export const assetPath = `${process.env.REACT_APP_ASSETS_URL || ""}assets`;
